<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card>
          <el-collapse v-model="activeName" @change="handleCollapse">
            <el-collapse-item :title="titleFilter" name="filter">
              <filter-component
                :filterOfBusinesses="true"
                :isRequiredFarms="true"
                @filter="handleFilter"
                @showHideLoading="showHideLoading"
                classBusinesses="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
                classFarms="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
                classLots="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
              >
                <template slot="after-lot">
                  <select-component
                    class="pt-3"
                    :rowClass="`col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3`"
                    :labelSelect="`${$t('common_words.type')}: *`"
                    :requireClass="`required-reportType`"
                    :dataOptions="reportTypes"
                    :initialSelection="dataFilter.reportType"
                    :isMultiple="false"
                    @onChange="handleChangeSelected"
                    modelName="reportType"
                  />
                </template>
              </filter-component>
            </el-collapse-item>
          </el-collapse>
        </card>
        <card v-if="tableData.length > 0">
          <div v-if="isIndex()">
            <card-header
              :propPagination="pagination"
              @searchedQuery="handleSearchQuery"
              class="mr-3 mt-4"
            />
            <master-table :infoTable="queriedData" :columns="tableColumns">
              <template slot="addColumnsOperations">
                <table-columns-operations
                  v-if="isShow() || isDelete()"
                  @handleView="handleView"
                  @handleDelete="handleDelete"
                  :resizable="false"
                  :showOperationEdit="false"
                  :viewingRecordId="rowData ? rowData.id : null"
                  fixed="right"
                />
              </template>
            </master-table>
            <card-footer ref="cardfooter" :propPagination="pagination" />
            <export-tables
              :pdf="{
                filename: '',
                route: '',
                showPDFButton: false,
              }"
              :xls="{
                filename: `${$t('calibration.detailed_multiple_report')}_${
                  dataFilter.datei
                }_${dataFilter.datef}.xlsx`,
                route: 'calibration/reports/excel/alldetailed',
                paramMethod: 'POST',
                plusData: { ...getDataToExport },
              }"
            />
          </div>
          <not-index-permissions v-else />
        </card>

        <div v-if="details" class="col-12 text-center">
          <em
            class="nc-icon nc-stre-up"
            style="font-size: 25px; cursor: pointer"
            @click="handleViewDetails"
            v-tooltip.top-center="$t('common_words.hide_detail')"
          ></em>
        </div>

        <card v-if="details && reportData">
          <div class="row">
            <div class="col-12">
              <p style="font-size: 17px" class="text-muted">
                {{ $t('common_words.inspection_related_information') }}:
              </p>
            </div>

            <div class="col-12 mb-2">
              <table aria-describedby="table-details" class="table">
                <tbody>
                  <tr class="shadow-sm">
                    <td>
                      <h6>
                        <strong>{{ $t('common_words.farm') }}:</strong>
                      </h6>
                      {{ reportData.header_info.farm }}
                    </td>
                    <td>
                      <h6>
                        <strong>{{ $t('common_words.allotment') }}:</strong>
                      </h6>
                      {{ reportData.header_info.lot }}
                    </td>
                    <td>
                      <h6>
                        <strong
                          >{{ $t('calibration.block_or_sector') }}:</strong
                        >
                      </h6>
                      {{ reportData.header_info.block }}
                    </td>
                    <th>
                      <img
                        v-tooltip.top-center="
                          $t('common_words.geo_location_map')
                        "
                        style="width: 30px; height: 30px"
                        class="pointer"
                        src="/static/img/iconos/map.svg"
                        :alt="$t('common_words.geo_location_icon')"
                        @click="handleViewDetailMap()"
                      />
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="col-12">
              <div class="row">
                <div
                  v-for="(value, key) in reportData.percentages"
                  :key="key"
                  class="col-12 col-md-6 col-lg-3 mb-2"
                >
                  <kpi
                    :label="`${key.toUpperCase()} %`"
                    :value="value"
                    unit="%"
                  />
                </div>
                <div class="col-12 col-md-6 col-lg-3 mb-2">
                  <kpi
                    :label="`${$t('calibration.total_calibrated')}`"
                    :value="reportData.table_details.total_calibrated"
                  />
                </div>
                <div class="col-12 col-md-6 col-lg-3 mb-2">
                  <kpi
                    :label="`${$t('calibration.number_of_total_bunches')}`"
                    :value="reportData.table_details.grand_total_racimos"
                  />
                </div>
              </div>

              <hr />

              <!-- Table Details -->
              <el-table
                :data="reportData.table_details.rows"
                border
                stripe
                style="width: 100%"
                :border="true"
                :max-height="tableHeight"
              >
                <el-table-column
                  :label="`${$t('common_words.age')}`"
                  width="100"
                  align="center"
                  fixed
                >
                  <template slot-scope="scope">
                    <div
                      class="font-weight-bold p-2 rounded"
                      :style="getAgeStyle(scope.row)"
                    >
                      {{ scope.row.age }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  :label="`${$t('calibration.calibration')}`"
                  align="center"
                >
                  <el-table-column
                    v-for="cal in reportData.table_details.calibration_headers"
                    :key="`cal-${cal}`"
                    :label="String(cal)"
                    min-width="90"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.calibrations[cal] || '' }}</span>
                    </template>
                  </el-table-column>
                </el-table-column>

                <el-table-column
                  :label="`${$t('calibration.total_cluster')}`"
                  prop="total_racimos"
                  min-width="100"
                  align="center"
                  class-name="font-weight-bold"
                ></el-table-column>

                <el-table-column
                  v-for="rangeInfo in reportData.table_details.range_headers"
                  :key="`range-${rangeInfo.name}`"
                  min-width="100"
                  align="center"
                >
                  <template v-slot:header>
                    <div
                      class="custom-th-header"
                      :style="getRangeHeaderStyle(rangeInfo)"
                    >
                      {{ rangeInfo.header }}
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <span class="font-weight-bold">
                      {{ scope.row.ranges[rangeInfo.name] || 0 }}
                    </span>
                  </template>
                </el-table-column>
              </el-table>
              <br />
              <export-tables
                :pdf="{
                  filename: '',
                  route: '',
                  showPDFButton: false,
                }"
                :xls="{
                  filename: `${$t('calibration.report_calibration')}_${
                    reportData.header_info.farm
                  }_${reportData.header_info.date_save}.xlsx`,
                  route: 'calibration/reports/excel/' + reportData.id,
                }"
              />
              <br />
            </div>
          </div>
        </card>

        <card v-if="tableData2.length > 0">
          <div v-if="isIndex()">
            <card-header
              :propPagination="pagination2"
              @searchedQuery="handleSearchQuery2"
              class="mr-3 mt-4"
            />
            <master-table :infoTable="queriedData2" :columns="tableColumns2">
            </master-table>
            <card-footer ref="cardfooter" :propPagination="pagination2" />
            <export-tables
              :pdf="{
                filename: '',
                route: '',
                showPDFButton: false,
              }"
              :xls="{
                filename: `${$t(
                  'calibration.report_calibration_consolidated'
                )}_${dataFilter.datei}_${dataFilter.datef}.xlsx`,
                route: 'calibration/reports/consolidated/excel',
                paramMethod: 'POST',
                plusData: { ...getDataToExport },
              }"
            />
            <br />
          </div>
        </card>
        <!-- Modal del Mapa -->
        <el-dialog
          :title="$t('common_words.geo_location_map')"
          :visible.sync="modals.map"
          width="80%"
          :before-close="handleCloseMap"
          class="zoom-map el-dialog-img-zoom"
        >
          <div ref="multipleMap" class="map"></div>
          <div id="toolbarDiv" class="esri-component esri-widget">
            <button
              id="distance"
              class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
              style="margin-bottom: 10px"
              :title="$t('common_words.distance_measurement_tool')"
            ></button>
            <button
              id="area"
              class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
              style="margin-bottom: 10px"
              :title="$t('common_words.area_measurement_tool')"
            ></button>
            <button
              id="clear"
              class="action-button esri-widget--button esri-interactive esri-icon-trash"
              style="margin-bottom: 10px"
              :title="$t('common_words.clear_measurement')"
            ></button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import configTable from './calibration-report-table';
import configTable2 from './calibration-reportConsolidated-table';
import Filter from 'src/components/Filter/Filters.vue';
import Fuse from 'fuse.js';
import i18n from 'src/i18n';
import Legend from 'src/views/Pages/Dashboard/AdvancedAudit/Components/Legend.vue';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinTable from 'src/mixins/mixin-table';
import { MixinExport } from 'src/mixins/mixin-export';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import Kpi from 'src/views/Layouts/Kpi.vue';
import { isset } from 'src/util/Util.js';
import paginationDataCalibrations from './paginationDataCalibrations';

export default {
  components: {
    [Kpi.name]: Kpi,
    [Filter.name]: Filter,
    Legend,
  },

  computed: {
    ...paginationDataCalibrations.functions,
    getDataToExport() {
      const response = { ...this.dataFilter };
      delete response.route;

      return response;
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    reportTypes() {
      return [
        { id: 'detallado', name: i18n.t('common_words.detailed') },
        { id: 'consolidado', name: i18n.t('common_words.consolidated') },
      ];
    },
  },

  data() {
    return {
      pagination: paginationDataCalibrations.pagination,
      pagination2: paginationDataCalibrations.pagination2,
      valueCollapse: null,
      activeName: 'filter',
      tableData: [],
      tableColumns: [],
      tableData2: [],
      tableColumns2: [],
      searchQuery: '',
      searchQuery2: '',
      fuseSearch2: null,
      details: false,
      reportData: null,
      inspectionForm: {},
      dataFilter: {
        datef: moment().format('YYYY-MM-DD'),
        datei: moment().subtract(1, 'year').format('YYYY-MM-DD'),
        farm: [],
        lot: [],
        reportType: 'detallado',
      },
      tableHeight: window.innerHeight * 0.9,
      // Propiedades para el mapa
      center: {
        lat: 0,
        lng: 0,
      },
      map: null,
    };
  },
  watch: {
    '$i18n.locale': ['setupTable'],
  },
  mixins: [
    MixinMasters,
    MixinPermissions,
    MixinMenu,
    MixinForm,
    MixinTable,
    MixinArcgisMap,
    MixinExport,
  ],

  methods: {
    handleSearchQuery(query) {
      this.searchQuery = query;
    },

    handleSearchQuery2(query) {
      this.searchQuery2 = query;
    },

    setupTable() {
      if (this.dataFilter.reportType == 'detallado') {
        const { Table } = configTable();
        this.pagination = { ...Table.pagination };
        this.tableColumns = Table.tableColumns;
        this.pagination.perPage = 10;
        this.pagination.currentPage = 1;
      } else {
        const { Table } = configTable2();
        this.tableColumns2 = Table.tableColumns2;
        this.pagination2 = { ...Table.pagination2 };
        this.pagination2.perPage = 10;
        this.pagination2.currentPage = 1;
      }
    },

    handleChangeSelected(data) {
      this.$set(this.dataFilter, data.name, data.selects);
      this.tableData = [];
      this.tableData2 = [];
      this.details = false;
      this.reportData = null;
    },

    handleViewDetailMap() {
      if (!this.hasLocationData()) {
        SweetAlert.warning(this.$t('boxinspection.no_locations_defined'));

        return;
      }

      this.modals.map = true;
      this.showHideLoading(true);
      let points = [];

      this.center.lat = this.rowData.latitude
        ? parseFloat(this.rowData.latitude)
        : this.center.lat;
      this.center.lng = this.rowData.longitude
        ? parseFloat(this.rowData.longitude)
        : this.center.lng;

      let pll = new Object();
      pll.lat = parseFloat(this.rowData.latitude);
      pll.lng = parseFloat(this.rowData.longitude);

      // Formatear fecha a YYYY-MM-DD
      const formattedDate = this.rowData.date_save
        ? moment(this.rowData.date_save).format('YYYY-MM-DD')
        : 'N/A';

      //Nombre de la finca
      const farmName = this.rowData.farm_name ? this.rowData.farm_name : 'N/A';

      // Crear título con la estructura solicitada
      pll.name = `${formattedDate}, ${farmName}`;
      points.push(pll);

      setTimeout(() => {
        this.loadBaseMap(
          this.rowData.farm_id,
          true,
          true,
          this.$refs.multipleMap,
          points,
          19
        );

        // Ajustar posición del toolbar del mapa
        const toolbarDiv = document.getElementById('toolbarDiv');
        if (toolbarDiv) {
          toolbarDiv.style = 'top: 16%;right: 18px;';
        }
        this.showHideLoading();
      }, 10);
    },

    handleCloseMap() {
      this.modals.map = false;
      // Limpiar el mapa si existe
      if (this.map) {
        this.map.destroy();
        this.map = null;
      }
    },

    hasLocationData() {
      if (!this.rowData) {
        return false;
      }

      const { latitude, longitude } = this.rowData;

      return isset(latitude) && isset(longitude);
    },

    getRangeHeaderStyle(rangeInfo) {
      return {
        backgroundColor: rangeInfo.color,
        color: rangeInfo.text_color,
      };
    },

    getAgeStyle(row) {
      const bgColor = row.color || '#E9ECEF';
      if (row.textColor) {
        return {
          backgroundColor: bgColor,
          color: row.textColor,
        };
      }

      const isLightBg = ['#ffffff', '#e9ecef', '#cccccc'].includes(
        bgColor.toLowerCase()
      );
      const textColor = isLightBg ? '#343A40' : '#FFFFFF';

      return {
        backgroundColor: bgColor,
        color: textColor,
      };
    },

    handleFilter(data) {
      this.dataFilter = {
        ...this.dataFilter,
        datef: data.datef,
        datei: data.datei,
        bySel: data.bySel,
        farm: data.farm,
        lot: data.lot,
      };
      this.details = false;
      this.reportData = null;
      this.searchedQuery = '';
      this.rowData = null;

      this.pagination.perPage = 10;
      this.pagination.currentPage = 1;

      this.pagination2.perPage = 10;
      this.pagination2.currentPage = 1;

      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.dataFilter.reportType)) {
            return this.validationInputsRequired('reportType');
          } else {
            this.getData();
          }
        }
      });
    },

    handleViewDetails() {
      this.details = !this.details;
      this.tableData.forEach((element) => {
        try {
          element.show = true;
        } catch (error) {
          //
        }
      });
      if (!this.details) {
        this.rowData = null;
      }
    },

    handleView(index, row) {
      this.showHideLoading(true);

      this.rowData = {
        ...row,
      };

      this.details = false;
      this.reportData = null;

      Axios.getMasters(`calibration/calibrationdetails/reports/${row.id}`)
        .then((response) => {
          this.reportData = response.data;
          this.details = true;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(
            error.response.data.message || 'Error al generar el reporte'
          );
        });
    },

    handleDelete(index, row) {
      this.inspectionForm = Object.assign({}, row);
      SweetAlert.delete(
        i18n.t('calibration.catch_calibration_date') +
          this.inspectionForm.date_save
      ).then((result) => {
        if (result.value) this.deleteCalibrationInspection();
      });
    },

    deleteCalibrationInspection() {
      this.showHideLoading(true);
      if (this.isDelete()) {
        this.inspectionForm.route = 'calibration/catchs/delete';
        Axios.destroyMaster(this.inspectionForm)
          .then((response) => {
            this.modifyTable(2, this.inspectionForm.id, response);
            this.showHideLoading();
            this.handleViewDetails();
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    getData() {
      this.showHideLoading(true);
      let data = this.dataFilter;

      if (data.bySel === 'Año') {
        data.datei += '-01-01';
        data.datef += '-12-31';
      }

      data.route = 'calibration/reports';
      Axios.postMasters(data)
        .then((response) => {
          const responseData = response.data.data;
          if (responseData.length === 0) {
            this.tableData = [];
            this.tableData2 = [];
            this.showHideLoading();
            return SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          }
          if (this.dataFilter.reportType === 'detallado') {
            this.tableData = responseData;
            this.fuseSearch = new Fuse(this.tableData, {
              useExtendedSearch: true,
              threshold: 0.3,
              keys: this.tableColumns.map((prop) => {
                return prop.prop;
              }),
            });

            this.showHideLoading();
          } else {
            //Se Generan las columnas dinámicamente
            const { Table } = configTable2();
            const staticColumnsConfig = Table.tableColumns2;
            const staticConfigMap = new Map(
              staticColumnsConfig.map((col) => [col.prop, col])
            );

            const allKeys = Object.keys(responseData[0]);

            const generatedColumns = allKeys.map((key) => {
              if (staticConfigMap.has(key)) {
                return staticConfigMap.get(key);
              }

              return {
                prop: key,
                label: key,
                minWidth: 160,
                sortable: true,
                align: 'center',
              };
            });

            this.tableColumns2 = generatedColumns;
            this.tableData2 = responseData;

            this.fuseSearch2 = new Fuse(this.tableData2, {
              useExtendedSearch: true,
              threshold: 0.3,
              keys: this.tableColumns2.map((prop) => {
                return prop.prop;
              }),
            });
            this.showHideLoading();
          }
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    updateTableHeight() {
      this.tableHeight = window.innerHeight * 0.9;
    },
  },
  created() {
    if (this.isIndex()) {
      this.setupTable();
    } else {
      this.showHideLoading();
    }
  },
  mounted() {
    this.selectedItemOnMenu('calibration');
  },

  destroyed() {
    this.deselectedItemOnMenu('calibration');
  },
};
</script>
<style scoped>
.danger-value {
  border-bottom: 4px solid #ff0000 !important;
}
.warning-value {
  border-bottom: 4px solid #ffff00 !important;
}
.success-value {
  border-bottom: 4px solid #008000 !important;
}
.successfully-value {
  border-bottom: 4px solid #0000ff !important;
}

.custom-th-header {
  font-weight: bold;
}
</style>
